import { h } from 'preact'
import { signal } from '@preact/signals'
import { tagParser } from '../../js/modules/utilities.js'

export const reassuranceEquipementState = signal('')

export const ReassuranceEquipement = (props) => {
   const { cacheKey, items } = props
   if (reassuranceEquipementState.value !== '' && reassuranceEquipementState.value['card3'] !== undefined) items.push(reassuranceEquipementState.value['card3'].items[0])

   return (
      <div class="container-fluid">
         <div id="zone_reassurance_mobile" data-testid="bande-reassurance-equipement" class="row mb-2 mb-md-4 reassurance-equipement" data-cache-key={cacheKey}>
            <h2 class="sr-only">Pourquoi acheter chez Orange</h2>
            {items.map((data, index) => (
               <Card {...data} index={index} />
            ))}
         </div>
      </div>
   )
}

const Card = ({ title, description, CTA, index }) => {
   let cappingAdv
   if (CTA.analytics.pdbSc === 'adv') {
      cappingAdv = {
         'data-pdb-ta': CTA.analytics.advTracker,
         'data-adv-canal': CTA.analytics.advCanal,
         'data-adv-cappingdata': CTA.analytics.advCappingdata,
      }
   }
   return (
      <div
         class="col-12 col-md-4 mt-2 mt-md-0 lien-composite-before"
         data-testid={`reassurance-equipement${index}`}
         data-pdb-zid={CTA.analytics.pdbZid}
         data-pdb-sc={CTA.analytics.pdbSc}
         data-pdb-idc={CTA.analytics.pdbIdc}
         data-pdb-vi="*"
         {...cappingAdv}
         data-oevent-category={CTA.analytics.oeventCategory}
         data-oevent-action={CTA.analytics.oeventAction}
         data-oevent-label={CTA.analytics.oeventLabel}
         data-oevent-other={CTA.analytics.oeventOther}
      >
         <div class="item">
            <h3 class="title mb-0" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></h3>
            <p class="mb-0 mb-md-1" dangerouslySetInnerHTML={{ __html: tagParser(description) }}></p>
            <a href={CTA.URL} class="cta mt-auto mw-100 o-link-arrow">
               <strong class="mw-100">{CTA.label}</strong>
            </a>
         </div>
      </div>
   )
}
